import Decimal from 'decimal.js'
import { Tag } from '-/Common/Tag'
import {
  TICKET_ERR_TYPE_COLOR,
  TICKET_ERR_TYPE_LABEL,
  TICKET_MODE_COLOR,
  TICKET_MODE_LABEL,
  TICKET_REPAY_RATIO_LOWER,
  TICKET_REPAY_RATIO_UPPER
} from '@/constant/biz'
import { useDictStore } from '@/store/modules/dict'

interface JtProjPointVillagesDisplayProps {
  text: string[]
}
/**
 * @component 集体土地项目-项目详情-涉及村/社区-展示
 */
export const JtProjPointVillagesDisplay = (props: JtProjPointVillagesDisplayProps) => {
  const { text = [] } = props
  return (
    <div>
      {text.map(item => (
        <Tag>{item}</Tag>
      ))}
    </div>
  )
}
interface JtZchSignStatusDisplayProps {
  // time?: string
  signFiles?: ApiFile.Item[]
}
/**
 * @component 集体土地项目-征拆户-签约状态-展示
 */
export const JtZchSignStatusDisplay = (props: JtZchSignStatusDisplayProps) => {
  // if (!props.time) return <Tag>未签约</Tag>
  // return (
  //   <div>
  //     <Tag color='success'>已签约</Tag>
  //     <div>签约时间：{props.time}</div>
  //   </div>
  // )
  if (props.signFiles?.length) return <Tag color='success'>已签约</Tag>
  return <Tag color='warning'>未签约</Tag>
}
interface JtZchRenYuanNameDisplayProps {
  name?: string
  isOwner?: number
}
/**
 * @component 集体土地项目-征拆户-人员-姓名
 */
export const JtZchRenYuanNameDisplay = (props: JtZchRenYuanNameDisplayProps) => {
  return (
    <div>
      {props?.name ?? '未知姓名'}
      {props.isOwner ? (
        <Tag color='blue' style={{ margin: '0  0 0 8px' }}>
          户主
        </Tag>
      ) : null}
    </div>
  )
}

export const getHouseText = (house: ApiHouse.Item, withCommunity = false) => {
  const res = `${house?.houseBuildingNumber ?? '未知'}号楼-${house?.houseUnitNumber ?? '未知'}单元-${house?.houseFloor ?? '未知'}楼-${
    house?.houseNumber ?? '未知房号'
  }`
  if (withCommunity) {
    return `${house?.community?.communityName ?? '未知小区'} ｜ ${res}`
  }
  return res
}
interface HouseDisplayProps {
  house: ApiHouse.Item
  withCommunity?: boolean
}
/**
 * @component 房源展示
 */
export const HouseDisplay = (props: HouseDisplayProps) => <>{getHouseText(props.house, props.withCommunity)}</>

interface GyProjAddressDisplayProps {
  value?: any[]
}
/**
 * @component 国有土地项目-所属区域
 */
export const GyProjAddressDisplay = (props: GyProjAddressDisplayProps) => {
  const dictStore = useDictStore()
  const { value = [] } = props
  let _text: string[] = []
  value.forEach(item => {
    if (item?.positionAddress) {
      _text = _text.concat(dictStore.word.get(item.positionAddress)?.label || '')
    }
  })
  _text = [...new Set(_text)]
  if (_text.length) {
    return <span>{_text.join('，')}</span>
  }
  return null
}
interface TicketModeDisplayProps {
  value: number
}
/**
 * @component 房票模式
 */
export const TicketModeDisplay = (props: TicketModeDisplayProps) => {
  const { value } = props
  return <Tag color={TICKET_MODE_COLOR[value]}>{TICKET_MODE_LABEL[value]}</Tag>
}

interface TicketMatchResultDisplayProps {
  matched: boolean
}
/**
 * 房票匹配结果
 */
export const TicketMatchResultDisplay = (props: TicketMatchResultDisplayProps) => {
  const { matched } = props
  return <Tag color={matched ? 'success' : 'warning'}>{matched ? '已匹配' : '未匹配'}</Tag>
}
/**
 * 房源状态展示
 */
interface HouseStatusDisplayProps {
  /** 是否安置 */
  isPlaced: number
  /** 是否分配 */
  isSet: number
}
export const HouseStatusDisplay = (props: HouseStatusDisplayProps): JSX.Element => {
  const { isPlaced, isSet } = props
  if (isPlaced === 1 && isSet === 1) {
    return <Tag color='success'>已分配已安置</Tag>
  } else if (isPlaced === 1 && isSet === 0) {
    return <Tag color='blue'>未分配已安置</Tag>
  } else if (isPlaced === 0 && isSet === 1) {
    return <Tag color='orange'>已分配未安置</Tag>
  } else {
    return <Tag color='warning'>未分配未安置</Tag>
  }
}

interface TicketPlanPriceColProps {
  value: number | string
  isImport: boolean
}
/**
 * 房票计划还款金额显示列
 */
export const TicketPlanPriceCol = (props: TicketPlanPriceColProps) => {
  const { value, isImport } = props
  return (
    <span>
      <Tag color={isImport ? 'success' : 'warning'}>{isImport ? '导入' : '预测'}</Tag>
      {value}
    </span>
  )
}

interface TicketErrTypeDisplayProps {
  errType?: number[]
}
/**
 * 房票异常类型展示组件
 */
export const TicketErrTypeDisplay = (props: TicketErrTypeDisplayProps) => {
  const { errType } = props
  if (errType?.length) {
    return (
      <div>
        {errType.map(type => (
          <Tag color={TICKET_ERR_TYPE_COLOR[type!]}>{TICKET_ERR_TYPE_LABEL[type!]}</Tag>
        ))}
      </div>
    )
  }
  return null
}

interface TicketRepayRatioDisplayProps {
  /** 比例 */
  record?: any
}
/**
 * 还款比例展示组件
 */
export const TicketRepayRatioDisplay = (props: TicketRepayRatioDisplayProps) => {
  const { yiHuanKuan = 0, yingHuanKuan = 0 } = props.record ?? {}
  if (!yingHuanKuan) return <Tag color='error'>0.00 %</Tag>

  const ratio = new Decimal(yiHuanKuan).div(yingHuanKuan)
  const percent = ratio.mul(100).toFixed(2)
  const isErr = ratio.lt(TICKET_REPAY_RATIO_LOWER) || ratio.gt(TICKET_REPAY_RATIO_UPPER)

  return <Tag color={isErr ? 'error' : 'success'}>{percent} %</Tag>
}
interface TicketLoanMatchStatusDisplayProps {
  matched: boolean
}
/**
 * 房票清单-放款匹配状态
 */
export const TicketLoanMatchStatusDisplay = (props: TicketLoanMatchStatusDisplayProps) => {
  const { matched } = props
  return <Tag color={matched ? 'success' : 'warning'}>{matched ? '已匹配' : '未匹配'}</Tag>
}
